<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [noBow]="true"
      [canGoBack]="true"
      [title]="'Edit Column'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />
    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <tidy-text
            [title]="column?.field_name" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'This column is in'" /><span>&nbsp;</span>
            <tidy-text
              [body]="report?.name + '.'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row>
            <tidy-checkbox
              [(checked)]="showColumn"
            [items]="[
              {
                viewValue: ('Show this column' | translate), value: true
              }
            ]"
            [initValue]="showColumn" />
        </tidy-row>
        <tidy-row>
          <tidy-checkbox
            [(checked)]="sortByThisColumn"
            [items]="[
              {
                viewValue: ('Sort by this column by default' | translate), value: true
              }
            ]"
          [initValue]="sortByThisColumn" />
      </tidy-row>
      @if (sortByThisColumn) {
        <tidy-row>
          <form [formGroup]="form" novalidate action="#">
            <tidy-select
              [form]="form.controls.sortType"
              formControlName="sortType"
              [icon]="'assets/svg/list.svg'"
              [items]="sortTypeItems" />
          </form>
        </tidy-row>
      }
    </tidy-card>
    @if (filters?.length == 0 && newFilters?.length == 0) {
      <tidy-row [alignLastItemRight]="column?.type !== 'date' && !isJobStatusField">
        <tidy-text
          [header]="'Column Filters'" />
        @if (column?.type !== 'date' && !isJobStatusField) {
          <tidy-text
            [body]="'Add Filter'"
            class="link"
            (action)="addFilter()" />
        }
      </tidy-row>
    }
    @if ((filters?.length !== 0 || newFilters?.length !== 0) && column?.type !== 'date') {
      <tidy-row>
        <tidy-text
          [header]="'Column Filters'" />
      </tidy-row>
    }
    @if (filters?.length == 0 && newFilters?.length == 0 && !isJobStatusField) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="'No filters added'" />
        </tidy-row>
      </tidy-alert>
    }
    @if (isJobStatusField && (filters?.length == 0 || newFilters?.length > 0)) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-text
              [body]="'Filter by job status (matches any of the selected):'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [form]="form.controls.value"
              formControlName="value"
              [label]="'Select job statuses'"
              [icon]="'assets/svg/flag.svg'"
              [items]="jobStatusOptions"
              [multiple]="true"
              [submitted]="submitted"
              [errorMessage]="'Please select at least one status.'" />
          </tidy-row>
        </form>
      </tidy-card>
    }
    @for (filter of filters; track filter) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          @if (column?.type !== 'date' && !isJobStatusField) {
            <tidy-text
              [body]="(filter?.operator | titlecase) + ': ' + filter?.value" />
          }
          @if (isJobStatusField) {
            <tidy-text
              [body]="('Status in: ' | translate) + filter?.value" />
          }
          @if (column?.type === 'date') {
            <tidy-text
              [body]="'Date filter applied'" />
          }
          <tidy-text
            [body]="'Remove'"
            (action)="removeFilter(filter)"
            class="link" />
        </tidy-row>
      </tidy-card>
    }
    @for (filter of newFilters; track filter) {
      @if (column?.type === 'number' || column?.type === 'string') {
        <tidy-card>
          <form [formGroup]="form" novalidate action="#">
            @if (!isJobStatusField) {
              <tidy-row class="field-bottom-padding">
                <tidy-select
                  [form]="form.controls.operator"
                  formControlName="operator"
                  [icon]="'assets/svg/list.svg'"
                  [items]="operatorItems" />
              </tidy-row>
            }
            @if (isJobStatusField) {
              <tidy-row>
                <tidy-text
                  [body]="'Filter by job status (matches any of the selected):'" />
              </tidy-row>
            }
            @if (isJobStatusField) {
              <tidy-row>
                <tidy-select
                  [form]="form.controls.value"
                  formControlName="value"
                  [label]="'Select job statuses'"
                  [icon]="'assets/svg/flag.svg'"
                  [items]="jobStatusOptions"
                  [multiple]="true"
                  [submitted]="submitted"
                  [errorMessage]="'Please select at least one status.'" />
              </tidy-row>
            }
            @if (!isJobStatusField) {
              <tidy-row>
                <tidy-input
                  [form]="form.controls.value"
                  formControlName="value"
                  [label]="'The following value'"
                  [icon]="'assets/svg/code.svg'"
                  [submitted]="submitted"
                  [errorMessage]="'Please select a value.'" />
              </tidy-row>
            }
            <tidy-row [align]="'center'" class="extra-top-padding">
              <tidy-text
                [body]="'Remove'"
                (action)="removeNewFilter()"
                class="link" />
            </tidy-row>
          </form>
        </tidy-card>
      }
    }
    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }
    <tidy-button
      [action]="boundSaveChanges"
      [text]="'Save Changes'"
      class="primary" />
  }
</tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
